<!--
 * @Description: 现金宝取现
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-30 15:32:31
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div v-if="xjbFundFileFlag">
        <comp-title-dc back-url-name="moneybox" :back-url-query="{ activeIndex: 2 }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/moneyBox' }">大成钱柜</el-breadcrumb-item>
                <el-breadcrumb-item>取现</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-money-out">
            <el-form
                ref="fundInfo"
                :rules="rules"
                :model="fundInfo"
                inline-message
                label-width="409px"
                v-on:submit.native.prevent
            >
                <el-form-item
                    label="取出账号："
                    prop="pay"
                    style="position: relative"
                    class="payway-list"
                >
                    <el-select v-model="fundInfo.pay" placeholder="请选择取出账号"></el-select>

                    <div
                        v-if="dialogBankLists.length > 0"
                        class="hot-area"
                        v-on:click="selectBank"
                    ></div>
                </el-form-item>
                <el-form-item label="可用余额：" prop="availableMoney">
                    <div class="available-money-box">
                        <div>
                            <span class="available-money">
                                {{ $util.fmtNum(fundInfo.availableMoney) }}
                            </span>
                            元
                        </div>
                        <div class="money-in" v-on:click="backFn">查看钱柜总资产</div>
                    </div>
                </el-form-item>
                <el-form-item label="取出金额：" prop="amount">
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                    />
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="确认金额：">
                    {{ $util.capitalRMB(fundInfo.amount) }}
                </el-form-item>
                <el-form-item label="巨额赎回处理：" prop="largeredemptionflag">
                    <el-select v-model="fundInfo.largeredemptionflag">
                        <el-option
                            v-for="item in $cache.getDict('110051')"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            单个开放日中，如果一只基金的净赎回申请超过该基金上一日基金总份额的10％时，即认为该基金发生了巨额赎回。
                            <br />
                            如果遇到巨额赎回，则提交的赎回份额会按一定比例赎回。
                            <br />
                            如果选择“放弃超额部分”则放弃赎回剩余部分。
                            <br />
                            如果选择“继续赎回”则剩余部分会作为下一工作日的赎回申请继续赎回。
                        </div>
                        <img
                            src="../../assets/img/tip.png"
                            class="w18 h18 ml12"
                            style="position: relative; top: 4px"
                        />
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="取出方式：" prop="sell">
                    <el-radio-group v-model="fundInfo.sell" class="padding-t-10">
                        <el-radio label="0" name="sell">
                            普通取出
                            <div class="sell-font">
                                T+1划款，多一天收益
                                <div class="margin-t-5">取出无限额</div>
                            </div>
                        </el-radio>
                        <el-radio label="1" name="sell">
                            快速取出
                            <div style="width: 170px" class="sell-font">
                                实时到账，取出当日无收
                                <div class="margin-t-5">
                                    益，限额单笔10000.00，单日{{
                                        $cache.getCompanyInfoParam("100152")
                                    }}
                                </div>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="16"
                    />
                    <!--                    <span-->
                    <!--                        class="redemp-btn margin-l-10"-->
                    <!--                        v-on:click.prevent="$router.push({ name: 'tradepwd' })"-->
                    <!--                    >-->
                    <!--                        <span class="like-a">忘记密码？</span>-->
                    <!--                    </span>-->
                </el-form-item>
                <el-form-item style="margin-left: -80px">
                    <div
                        v-if="xjbFundFile.length !== 0"
                        class="check-box bar-pad showChenckbox"
                        style="
                            font-size: 14px;
                            display: flex;
                            align-items: flex-start;
                            padding-left: -10px;
                        "
                    >
                        <ul>
                            <li
                                v-for="(item, index) in xjbFundFile"
                                :key="index"
                                class="flex hcenter"
                            >
                                <el-checkbox
                                    v-model="checkboxs[index].checkbox"
                                    size="mini"
                                    text-color="red"
                                ></el-checkbox>
                                <div>
                                    <span class="ml4 c_999">同意</span>
                                    <a
                                        v-if="item.fileid"
                                        class="file-content"
                                        target="_blank"
                                        v-on:click="getClick(index)"
                                    >
                                        《{{ item.title }}》
                                    </a>
                                    <span v-else class="file-content" v-on:click="argRead(item)">
                                        《{{ item.title }}》
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="margin-top: 20px">
                        <el-button class="back-btn" v-on:click="backFn">返回重选</el-button>
                        <el-button
                            :class="
                                'confirm-btn ' +
                                (disabeldFlag || isOpen ? 'disable-btn' : 'active-btn')
                            "
                            :loading="isOpen"
                            :disabled="disabeldFlag || isOpen"
                            v-on:click="submitInfo()"
                        >
                            确定
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <select-bank
                dialog-title="请选择取出账号"
                :dialog-bank-lists="dialogBankLists"
                :select-bank-show="selectBankShow"
                v-on:select-bank-close="selectBankClose"
                v-on:select-bank-info="selectBankInfo"
            ></select-bank>
            <el-dialog
                title="取出结果"
                :visible.sync="resultDialog"
                class="prop info-tips"
                width="700px"
                :before-close="resultDialogClose"
            >
                <div>
                    <div class="success-res">
                        <div>
                            <img src="../../assets/img/buy_success.png" alt="" />
                        </div>
                        <div class="success-text">您好，取出成功！</div>
                    </div>
                    <div class="btn-box">
                        <button class="btn-confirm" v-on:click="resultDialogClose">确定</button>
                    </div>
                </div>
            </el-dialog>
            <pdf-popup
                base64
                :visible="pdfVisible"
                :need-time="needTime"
                :read-file-info-list="currentFileInfoList"
                v-on:close="pdfVisible = false"
            ></pdf-popup>
            <my-dialog
                :title="agrData.title"
                :visible.sync="agrVisible"
                :dialog-close="agrVisibleHide"
                width="800px"
            >
                <div class="protocol-detail" v-html="agrData.content"></div>
                <div class="align-c">
                    <el-button type="primary" style="width: 180px" v-on:click="agrVisible = false">
                        确定
                    </el-button>
                </div>
            </my-dialog>
            <fund-protocol v-model="protocol" :fund="protocolFund" v-on:all-read="generalBuy" />
        </div>
        <footer-questions :warning-html="warningHtml"></footer-questions>
    </div>
</template>
<script>
import selectBank from "@/components/layout/selectBank.vue";
import userApi from "@/api/user";
import mixin from "@/assets/js/mixin";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import myDialog from "@/components/layout/myDialog.vue";
import fundProtocol from "@/components/form/fundProtocol";
import footerQuestions from "@/components/layout/footerQuestions.vue";

export default {
    name: "MoneyOut",
    components: { selectBank, PdfPopup, myDialog, fundProtocol, footerQuestions },
    mixins: [mixin],
    data() {
        return {
            fund: {},
            fundcode: "",
            xjbFundFile: [],
            xjbFundFileFlag: false,
            currentFileInfoList: [], // 当前阅读信批文件
            checkboxs: [],
            pdfVisible: false,
            protocol: false,
            protocolFund: {},
            needTime: false,
            agrVisible: false,
            agrData: {},
            pla: "请输入取出金额",
            isOpen: false,
            fundInfo: {
                pay: "",
                availableMoney: "0",
                amount: "",
                largeredemptionflag: "",
                sell: "0",
                pwd: ""
            },
            isPwdCheck: false,
            resultDialog: false,
            selectBankShow: false,
            dialogBankLists: [],
            bankInfo: {},
            limit: { text: "存入金额范围为：", min: "0", max: "0" }, // 限额
            rules: {
                // 校验规则配置
                pay: [
                    {
                        required: true,
                        message: "请选择取出账号",
                        trigger: "change"
                    }
                ],
                amount: [
                    {
                        validator: this.amountLimit,
                        mes: "取出金额",
                        trigger: "change"
                    }
                ],
                largeredemptionflag: [
                    {
                        required: true,
                        message: "请选择巨额赎回方式",
                        trigger: "change"
                    }
                ],
                sell: [
                    {
                        required: true,
                        message: "请选择取出方式",
                        trigger: "change"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            limitData: {
                minredemptionvol: "0",
                maxredemptionvol: "0",
                fastminredemptionvol: "0",
                fastmaxredemptionvol: "10000"
            },
            warningHtml:
                "“自动存入”指的是定期定额申购大成添利宝E(000726)， “自动取出“指的是定期定额赎回大成添利宝E(000726)。"
        };
    },
    computed: {
        disabeldFlag() {
            if (this.checkboxs.length == 0) {
                return false;
            }
            for (let i = 0; i < this.checkboxs.length; i++) {
                if (!this.checkboxs[i].checkbox) {
                    return true;
                }
            }
            return false;
        }
    },
    watch: {
        "fundInfo.sell"(val) {
            const bankSetMin =
                val == "0" ? this.limitData.minredemptionvol : this.limitData.fastminredemptionvol;
            const bankSetMax =
                val == "1" ? this.limitData.maxredemptionvol : this.limitData.fastmaxredemptionvol;
            this.$set(this.limit, "min", bankSetMin);
            this.$set(
                this.limit,
                "max",
                Number(bankSetMax) - Number(this.fundInfo.availableMoney) > 0
                    ? this.fundInfo.availableMoney
                    : bankSetMax
            );
            this.pla =
                this.$util.fmtNum(this.limit.min) +
                "元起，最多可取现" +
                this.$util.fmtNum(this.limit.max) +
                "元";
        }
    },
    mounted() {
        this.isPwdCheck = this.$cache.getPwdCheck("024");
        this.queryXjbFundInfo();
    },
    methods: {
        // 查询现金宝信息
        async queryXjbFundInfo() {
            const res = await fundApi.cfgFundrealtimeQueryAll();
            this.fundcode = res.data && res.data[0] && res.data[0].fundcode;
            if (!this.fundcode) {
                this.$message({
                    type: "warning",
                    message: "未配置现金宝信息！"
                });
                return false;
            }
            const fundRes = await fundApi.getFundLists({
                fundcode: this.fundcode,
                pagesize: 10,
                pagenum: 1
            });
            if (fundRes.data) {
                this.fund = fundRes.data.list[0];
                this.getFileInfo();
                this.getBuyWay();
            }
        },
        // 赎回前查询
        async getBuyWay() {
            let rs = await fundApi.qryBeforeRedeem({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            if (rs.data) {
                this.limitData.minredemptionvol = rs.data.minredemptionvol
                    ? rs.data.minredemptionvol
                    : "0";
                this.limitData.maxredemptionvol = rs.data.maxredemptionvol;
                this.limitData.fastminredemptionvol = rs.data.fastminredemptionvol
                    ? rs.data.fastminredemptionvol
                    : "0";
                if (!rs.data.fastmaxredemptionvol) {
                    this.limitData.fastmaxredemptionvol = 10000;
                } else {
                    this.limitData.fastmaxredemptionvol =
                        Number(rs.data.fastmaxredemptionvol) - 10000 > 0
                            ? 10000
                            : Number(rs.data.fastmaxredemptionvol);
                }
            }
            const res = await fundApi.getHoldingAssets({
                fundcode: this.fund.fundcode
            });
            this.dialogBankLists = res.data.returnList;
            this.dialogBankLists = this.dialogBankLists.filter((item) => {
                return Number(item.usableremainshare) > 0;
            });
            const reqRes = await userApi.getMyBankCards();
            if (reqRes.data.data) {
                this.dialogBankLists.forEach((item) => {
                    reqRes.data.data.forEach((reqItem) => {
                        if (reqItem.paycenterid + reqItem.bankcode == item.channelid) {
                            item.perdaymax = reqItem.perdaymax;
                            item.maxlimitsingle = reqItem.maxlimitsingle;
                        }
                    });
                });
                // 如果点确认回到取现界面得刷新当前界面数据
                // if (buyFresh) {
                //     const currentBank = this.dialogBankLists.filter((item) => {
                //         return (
                //             this.bankInfo.channelid == item.channelid &&
                //             this.bankInfo.transactionaccountid == item.transactionaccountid
                //         );
                //     });
                //     this.selectBankInfo(currentBank[0]);
                // }
            }
        },
        // 获取提示文件信息
        async getFileInfo() {
            this.fund.proto = "sell";
            this.$util.getSdxProtocol(this.fund, (res) => {
                this.fund = res;
                this.protocolFund = JSON.parse(JSON.stringify(res));
                this.protocolFund.protoArr = [];
                if (res.protoArr && res.protoArr.length > 0) {
                    res.protoArr.forEach((item) => {
                        item.filename = item.title;
                        if (item.fileid == null || !item.fileid) {
                            item.fileid = "";
                        }
                        this.xjbFundFile.push(item);
                        this.checkboxs.push({ checkbox: false });
                    });
                }
                this.xjbFundFileFlag = true;
            });
        },
        getClick(index) {
            this.currentFileInfoList = [this.xjbFundFile[index]];
            this.needTime = false;
            this.pdfVisible = true;
        },
        backFn() {
            this.$router.push({
                name: "moneybox"
            });
        },
        submitInfo() {
            this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    this.protocol = true;
                } else {
                    this.$errorScroll();
                }
            });
        },
        generalBuy(val) {
            this.protocol = false;
            if (!val) return;
            let data = {
                transactionaccountid: this.bankInfo.realtransactionaccountid,
                tradepassword: this.$util.enc(this.fundInfo.pwd),
                applicationvol: this.fundInfo.amount,
                fastredeemflag: this.fundInfo.sell
            };
            // 下单
            this.planOpen(data);
        },
        async planOpen(params) {
            this.isOpen = true;
            try {
                const res = await fundApi.combTransRealtaRedeem(params);
                if (res.data) {
                    this.resultDialog = true;
                }
            } catch (e) {
                this.$log.error(e);
            } finally {
                this.isOpen = false;
            }
        },
        // 处理限额
        amountLimit(rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        selectBank() {
            this.selectBankShow = true;
        },
        selectBankClose(value) {
            this.selectBankShow = false;
        },
        selectBankInfo(bankInfo) {
            this.bankInfo = bankInfo;
            this.fundInfo.pay =
                this.bankInfo.paycentername +
                "-" +
                this.$cache.getDict("110080", this.bankInfo.bankcode) +
                "(**" +
                this.bankInfo.depositcard.slice(-4) +
                ")";
            this.fundInfo.availableMoney = this.bankInfo.usableremainshare
                ? this.bankInfo.usableremainshare
                : "0.00";
            const bankSetMin =
                this.fundInfo.sell == "0"
                    ? this.limitData.minredemptionvol
                    : this.limitData.fastminredemptionvol;
            const bankSetMax =
                this.fundInfo.sell == "1"
                    ? this.limitData.maxredemptionvol
                    : this.limitData.fastmaxredemptionvol;
            this.$set(this.limit, "min", bankSetMin);
            this.$set(
                this.limit,
                "max",
                Number(bankSetMax) - Number(this.fundInfo.availableMoney) > 0
                    ? this.fundInfo.availableMoney
                    : bankSetMax
            );
            this.pla =
                this.$util.fmtNum(this.limit.min) +
                "元起，最多可取现" +
                this.$util.fmtNum(this.limit.max) +
                "元";
        },
        agrVisibleHide() {
            this.agrVisible = false;
        },
        argRead(item) {
            this.agrVisible = true;
            this.agrData = item;
        },
        resultDialogClose() {
            this.resultDialog = false;
            this.$router.push({ name: "moneybox" });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-money-out {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-top: 40px;
    margin-bottom: 20px;
    .payway-list {
        position: relative;
        .hot-area {
            width: 400px;
            height: 40px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99 !important;
            cursor: pointer;
        }
        .add-bank-btn {
            position: absolute;
            left: 410px;
            font-size: 14px;
            font-weight: normal;
            color: #1890ff;
            cursor: pointer;
        }
    }
    .available-money-box {
        display: flex;
        align-items: center;
        .available-money {
            font-size: 22px;
            font-weight: normal;
            color: #e60012;
            vertical-align: top;
        }
        .money-in {
            text-align: center;
            padding: 5px 9px;
            height: 26px;
            line-height: 26px;
            border-radius: 20px;
            background: #ffecec;
            font-size: 14px;
            font-weight: normal;
            color: #e60012;
            margin-left: 29px;
            cursor: pointer;
        }
    }

    .back-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: #e4e4e4;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #666666;
        border: none;
        cursor: pointer;
    }
    .confirm-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        border: none;
        margin-left: 40px;
    }
    .active-btn {
        background: #e60012;
        cursor: pointer;
    }
    .disable-btn {
        background: #f7b2b8;
    }
    .success-res {
        margin: 40px 0 30px;
        width: 660px;
        height: 242px;
        border-radius: 6px;
        background: #f9f9f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .success-text {
            font-size: 26px;
            font-weight: 500;
            margin-top: 23.85px;
            color: #333333;
        }
    }
    .btn-box {
        text-align: center;
        padding-bottom: 56px;
        .btn-confirm {
            width: 180px;
            text-align: center;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            background: #e60012;
            color: #ffffff;
            border: none;
            cursor: pointer;
        }
    }
    .file-content {
        text-decoration: none;
        color: #e60012;
        cursor: pointer;
    }
    .protocol-detail {
        padding: 20px 10px;
        max-height: 80vh;
        min-height: 10vh;
        overflow: scroll;
    }
    .el-input,
    .el-select {
        width: 400px;
    }
    .el-input__inner {
        font-size: 22px !important;
        font-weight: normal;
        color: #333333;
    }
    .margin-l-10 {
        margin-left: 10px;
    }
    :deep(.el-form-item__label) {
        padding: 0;
        font-size: 14px;
        font-weight: normal;
        color: #333333;
    }
    :deep(.el-form-item__label:before) {
        display: none;
    }
    .padding-t-10 {
        padding-top: 10px;
    }
    .padding-t-10 {
        padding-top: 10px;
    }
    .margin-t-5 {
        margin-top: 5px;
    }
    .sell-font {
        font-size: 14px;
        color: #999999;
    }
}
</style>
